<template>
  <section class="section">
    <table-ag
      v-if="datos"
      :rowData="datos"
      :columnDefs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      @selected="selected"
    ></table-ag>
    <!-- Components -->
    <transition name="slide">
      <MenuCreateFrp
        v-if="showMenuCreate"
        :data="processEdit"
        @closeMenuCreate="closeMenuCreate"
        @getProcesses="getData"
      >
      </MenuCreateFrp>
    </transition>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
import tableAg from "../dashboard/tableAg.vue";
import MenuCreateFrp from "./components/menuCreateFrp.vue";
import menuTableDataFrp from "./components/menuTableDataFrp.vue";
import buttonsActionFrsp from "./components/buttons-action.vue";

export default {
  components: {
    tableAg,
    MenuCreateFrp,
  },
  data() {
    return {
      datos: [],
      processEdit: {},
      columns: [
        {
          field: "nombre",
          headerName: "Proceso",
          editable: true,
          suppressKeyboardEvent: (params) => {
            return this.suppressEnter(params);
          },
          cellRenderer: (params) => {
            return `${this.formatTypeProcess(params)} ${params.value}`;
          },
        },
        {
          field: "status",
          headerName: "Estado",
          editable: false,
          cellRenderer: (params) => {
            return `<span class="tag is-success">${
              params.value === "creado" ? "Creado" : params.value
            }</span>`;
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "created",
          headerName: "Creación",
          editable: false,
          cellRenderer: (params) => {
            return new Date(params.value).toISOString().slice(0, 10);
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "_id",
          headerName: "Controles",
          hide: this.tokenUser ? this.tokenUser.cliente : true,
          colId: "_actions",
          editable: false,
          cellRenderer: "ButtonsActionFrsp",
          cellRendererParams: { tokenUser: this.tokenUser },
        },
      ],
      components: {
        ButtonsActionFrsp: () => {
          return {
            render: (h) =>
              h(buttonsActionFrsp, {
                props: {},
                on: {
                  editProcess: this.editProcess,
                },
              }),
          };
        },
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableDataFrp, {
              props: {},
              on: {
                closeMenuCreate: this.closeMenuCreate,
              },
            }),
        };
      },
      showMenuCreate: false,
    };
  },
  props: {
    tokenUser: Object,
  },
  computed: {
    ...mapState(["idtoken"]),
  },
  methods: {
    selected(d) {
      this.$emit("selFrs", d);
    },
    async getData() {
      const _this = this;
      let result;
      try {
        result = await apiServices.get(`/frplist`);
        _this.datos = result.data.map((el) => {
          return {
            nombre: el.nombre,
            id: el._id,
            cliente: el.cliente.nombre,
            status: el.status,
            responses: el.agrupadoras,
            dataAdmin: el.data,
            test: el.test,
            created: el.created,
          };
        });
      } catch (err) {
        console.log(err);
      }
    },
    closeMenuCreate() {
      this.showMenuCreate = !this.showMenuCreate;
      if (!this.showMenuCreate) this.processEdit = {};
    },
    editProcess(data) {
      this.processEdit = data;
      this.closeMenuCreate();
    },
    // Helpers
    formatTypeProcess(p) {
      if (p.data.test)
        return `<span class="tag tag-process is-success is-capitalized">Prueba</span>`;
      return "";
    },
    suppressEnter(params) {
      const KEY_ENTER = "Enter";

      const event = params.event;
      const key = event.key;
      const suppress = key === KEY_ENTER;

      return suppress;
    },
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.getData();
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.getData();
    }
  },
};
</script>
<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}
.slide-enter {
  transform: translateX(30vw);
}

.slide-enter-active {
  transition: all 0.3s ease-in;
}

.slide-leave-active {
  transition: all 0.3s ease-in;
}
.slide-leave-to {
  transform: translateX(30vw);
}

.slide-two-enter {
  transform: translateX(30vw);
}

.slide-two-enter-active {
  transition: all 0.3s ease-in;
}

.slide-two-leave-active {
  transition: all 0.3s ease-in;
}
.slide-two-leave-to {
  transform: translateX(30vw);
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/DatosFrs.vue